import { request } from '@/utils/request'

const TOKEN_KEY = 'fanqianai_admin_token'
const USER_KEY = 'fanqianai_admin_user'

// 从localStorage获取token和用户信息
function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY)
}

function getStoredUser() {
  const userStr = localStorage.getItem(USER_KEY)
  return userStr ? JSON.parse(userStr) : null
}

function setStoredToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  } else {
    localStorage.removeItem(TOKEN_KEY)
  }
}

function setStoredUser(user) {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  } else {
    localStorage.removeItem(USER_KEY)
  }
}

const state = {
  token: getStoredToken(),
  user: getStoredUser(),
  isAuthenticated: !!getStoredToken(),
  loginLoading: false
}

const getters = {
  token: state => state.token,
  user: state => state.user,
  isAuthenticated: state => state.isAuthenticated,
  userType: state => state.user?.type,
  userRole: state => state.user?.role,
  username: state => state.user?.username,
  isAdmin: state => state.user?.type === 'admin',
  isAgent: state => state.user?.type === 'agent',
  isSuperAdmin: state => state.user?.type === 'admin' && state.user?.role === 'super_admin',
  loginLoading: state => state.loginLoading
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    state.isAuthenticated = !!token
    setStoredToken(token)
  },
  
  SET_USER(state, user) {
    state.user = user
    setStoredUser(user)
  },
  
  SET_LOGIN_LOADING(state, loading) {
    state.loginLoading = loading
  },
  
  CLEAR_AUTH(state) {
    state.token = null
    state.user = null
    state.isAuthenticated = false
    setStoredToken(null)
    setStoredUser(null)
  }
}

const actions = {
  // 管理员登录
  async adminLogin({ commit }, { username, password }) {
    commit('SET_LOGIN_LOADING', true)
    try {
      const response = await request.post('/auth/admin/login', {
        username,
        password
      })
      
      const { token, user } = response.data
      
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      
      return response
    } finally {
      commit('SET_LOGIN_LOADING', false)
    }
  },
  
  // 代理商登录
  async agentLogin({ commit }, { username, password }) {
    commit('SET_LOGIN_LOADING', true)
    try {
      const response = await request.post('/auth/agent/login', {
        username,
        password
      })
      
      const { token, user } = response.data
      
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      
      return response
    } finally {
      commit('SET_LOGIN_LOADING', false)
    }
  },
  
  // 获取当前用户信息
  async getCurrentUser({ commit }) {
    try {
      const response = await request.get('/auth/me')
      commit('SET_USER', response.data)
      return response
    } catch (error) {
      // 如果获取用户信息失败，清除认证状态
      commit('CLEAR_AUTH')
      throw error
    }
  },
  
  // 修改密码
  // eslint-disable-next-line no-unused-vars
  async changePassword({ commit }, { oldPassword, newPassword }) {
    return await request.post('/auth/change-password', {
      old_password: oldPassword,
      new_password: newPassword
    })
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_AUTH')
    // 可以在这里调用后端登出接口
    return Promise.resolve()
  },
  
  // 刷新token（如果后端支持）
  async refreshToken({ commit, state }) {
    try {
      const response = await request.post('/auth/refresh', {
        token: state.token
      })

      const { token } = response.data
      commit('SET_TOKEN', token)

      return response
    } catch (error) {
      // 刷新失败，清除认证状态
      commit('CLEAR_AUTH')
      throw error
    }
  },

  // 更新用户信息
  async updateUserInfo({ commit, state }, updateData) {
    // 更新本地存储的用户信息
    const updatedUser = {
      ...state.user,
      ...updateData
    }
    commit('SET_USER', updatedUser)

    return updatedUser
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
